import z from 'zod';
import { UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBTimestampSchema } from '../common/sql';

/**
 * DB Schemas
 *
 * A printed question is one the survey found in a document, such as
 * "Question 12". It may be split into several independent questions.
 */

export const DBDocumentQuestionIdSchema = UUIDSchema;
export const DBDocumentQuestionPositionSchema = z.number().int().positive();
export const DBDocumentQuestionOriginalQuestionNumberSchema = z.string().min(1).max(64);
export const DBDocumentQuestionPageSchema = z.number().int().positive();
export const DBDocumentQuestionSolutionPagesSchema = z.array(DBDocumentQuestionPageSchema);

export const DBDocumentQuestionSchema = z.object({
  id: DBDocumentQuestionIdSchema,
  sourceDocumentId: UUIDSchema,
  position: DBDocumentQuestionPositionSchema,
  originalQuestionNumber: DBDocumentQuestionOriginalQuestionNumberSchema,
  startPage: DBDocumentQuestionPageSchema,
  endPage: DBDocumentQuestionPageSchema,
  solutionPages: DBDocumentQuestionSolutionPagesSchema,
  questionPrinted: z.boolean(),
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

/**
 * Client Schemas
 */

export const DocumentQuestionIdSchema = DBDocumentQuestionIdSchema;
export const DocumentQuestionPositionSchema = DBDocumentQuestionPositionSchema.openapi({
  description: 'The order of the printed question in its paper, from 1',
  example: 12,
});
export const DocumentQuestionOriginalQuestionNumberSchema =
  DBDocumentQuestionOriginalQuestionNumberSchema.openapi({
    description: 'The question number the paper prints. Not unique within a paper.',
    example: '12',
  });
export const DocumentQuestionSolutionPagesSchema = DBDocumentQuestionSolutionPagesSchema.openapi({
  description: 'The pages the survey found the solution on, empty where it found none',
  example: [14],
});
export const DocumentQuestionQuestionPrintedSchema = z.boolean().openapi({
  description: "Whether the paper prints the question's own wording, as the survey read it",
  example: true,
});

export const DocumentQuestionSchema = z.object({
  id: DocumentQuestionIdSchema,
  sourceDocumentId: UUIDSchema,
  position: DocumentQuestionPositionSchema,
  originalQuestionNumber: DocumentQuestionOriginalQuestionNumberSchema,
  startPage: DBDocumentQuestionPageSchema,
  endPage: DBDocumentQuestionPageSchema,
  solutionPages: DocumentQuestionSolutionPagesSchema,
  questionPrinted: DocumentQuestionQuestionPrintedSchema,
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});
